import { baseAppApi } from '@/core/network/baseAppApi';
import dashboardReducer, { DASHBOARD_STORE_KEY } from '@/dashboard/redux/dashboardReducer';
import schedulesReducer, { SCHEDULES_STORE_KEY } from '@/schedules/redux/schedulesReducer';
import importPayrollReducer, { IP_STORE_KEY } from '@/import-payroll/redux/importPayrollReducer';
import payrollPeriodReducer, { PP_STORE_KEY } from '@/payroll-period/redux/payrollPeriodReducer';
import commonReducer, { COMMON_STORE_KEY } from '@/core/store/commonReducer';

const appReducers = {
  [baseAppApi.reducerPath]: baseAppApi.reducer,
  [COMMON_STORE_KEY]: commonReducer,
  [IP_STORE_KEY]: importPayrollReducer,
  [DASHBOARD_STORE_KEY]: dashboardReducer,
  [PP_STORE_KEY]: payrollPeriodReducer,
  [SCHEDULES_STORE_KEY]: schedulesReducer,
};

export { appReducers };
